import classNames from 'classnames';

import { Typography } from '@/components/Typography';

export function SiteSearchSectionLabel({
  label,
  addTopMargin = false,
}: {
  label: string;
  addTopMargin?: boolean;
}) {
  return (
    <div
      className={classNames('flex mb-1', {
        'mt-4': addTopMargin,
      })}
    >
      <Typography
        name="tag-300"
        tag="p"
        className="pb-1 border-b border-gray-400"
      >
        {label}
      </Typography>
    </div>
  );
}
